import { signal } from "@preact/signals-react";

const user_info = signal(false);
const form_list = signal(false);
const confirm_type = signal('');
const selected_form_id = signal('');

export {
    user_info,
    form_list,
    confirm_type,
    selected_form_id
}